











































































import * as _ from "lodash";
import {
  IresDevice,
  isActiveProgramChainOfIresDevice,
} from "@/data/models/IresDevice";
import {
  getDryingPhaseInfoOfProgramChain,
  ProgramChain,
} from "@/data/models/ProgramChain";

import {
  ProgramChainQualityRating,
  DryingLabel,
} from "@/data/models/ProgramChainQualityRating";

import { setQualityRatingOfProgramChain } from "@/data/repository/ProgramChainRepository";
import { Vue, Component, Prop, Ref } from "vue-property-decorator";
import { ProgramQualityRating } from "@/data/models/ProgramQualityRating";
import { DryingQualityRating } from "@/data/models/DryingQualityRating";
import { firestore } from "firebase";
import { getClientId } from "@/data/repository/ClientRepository";
import { isMonitorProgramOfComBox, isRoomDryingProgram, isTargetDryingProgram } from "@/data/models/ComBox";
import {
  getActiveUser,
  getActiveUserId,
} from "@/data/repository/UserRepository";
import { OverallDryingRating } from "@/data/models/OverallDryingRating";
import { formatDate } from "@/utils/DateFormatter";
import { joinToString } from "@/utils/LocalisationHelper";
import { isPostDryingProgram } from "@/data/models/ComBox";

import ProgramChainNotesComponent from "../ProgramChainNotes.vue";
import ConfirmationDialogComponent from "@/components/common/ConfirmationDialog.vue";
import RateOverallDryingQualityComponent from "./RateOverallDryingQuality.vue";
import DryingInfoItemComponent from "@/components/devices/DryingInfoItem.vue";
import DryingProgressGraphComponent from "@/components/panel/DryingProgressGraph.vue";
import DryingProgressGraphLegendComponent from "@/components/panel/DryingGraphLegend.vue";
import RateProgramQualityComponent from "@/components/devices/ratedrying/RateProgramQuality.vue";
import RateDryingQualityComponent from "@/components/devices/ratedrying/RateDryingQuality.vue";
import PhaseQualityOverviewComponent from "@/components/devices/ratedrying/PhaseQualityOverview.vue";
import LabelDryingComponent from "@/components/devices/ratedrying/LabelDrying.vue";
import NotesComponent from "@/components/devices/ratedrying/Notes.vue";
import RateDryingDurationComponent from "@/components/devices/ratedrying/RateDryingDuration.vue";
import { DryingDurationRating } from "@/data/models/DryingDurationRating";
import { NotesDryingRating } from "@/data/models/NotesDryingRating";

@Component({
  components: {
    "label-drying": LabelDryingComponent,
    "rate-drying-duration": RateDryingDurationComponent,
    "drying-info-item": DryingInfoItemComponent,
    "drying-progress": DryingProgressGraphComponent,
    "drying-progress-legend": DryingProgressGraphLegendComponent,
    "rate-program-quality": RateProgramQualityComponent,
    "rate-drying-quality": RateDryingQualityComponent,
    "program-chain-notes": ProgramChainNotesComponent,
    "phase-quality-overview": PhaseQualityOverviewComponent,
    "rate-overall-drying-quality": RateOverallDryingQualityComponent,
    "confirmation-dialog": ConfirmationDialogComponent,
    "notes": NotesComponent,
  },
})
export default class RateDryingComponent extends Vue {
  isLoading = true;

  @Prop()
  iresDevice!: IresDevice;

  @Prop()
  programChain!: ProgramChain;

  @Ref("confirmSaveRateDrying")
  confirmationDialog!: ConfirmationDialogComponent;

  mounted() {
    this.showRatingInfo(this.programChain);
  }

  phases: number[] = [];

  didEditNoteText = false;
  noteText = "";

  dryingQualityRating: DryingQualityRating = {
    dryingSpeed: null,
    flow: null,
    roomTemperature: null,
    roomHumidity: null,
  };

  overallDryingRating: OverallDryingRating = {
    dryingDuration: null,
    dryingProcess: null,
    knowledgeGain: null,
  };

  labels: DryingLabel[] = [];
  notesDryingRating: NotesDryingRating = {
    anomalies: [],
    general: [],
    roomConditions: [],
    roomTemperature: [],
    EDTGeneral: [],
    EDTPhase4: [],
    EDTPauses: [],
  }
  
  dryingDurationRating: DryingDurationRating = {
    shouldHaveRunLonger: null,
    shouldHaveStoppedAt: null,
  };

  programQualityRating: ProgramQualityRating = {
    phaseRatings: {},
  };

  shouldSaveMigration = false;
  isSavingRating = false;
  showRatingSavedSnackbar = false;

  get programNumber() {
    return this.programChain.runs[0].programNumber ?? 1;
  }

  get isMonitorProgramChain() {
    const firstRun = this.programChain.runs[0];

    return isMonitorProgramOfComBox(firstRun?.programNumber ?? 1);
  }

  get showPhaseQualityOverview() {
    return !this.isMonitorProgramChain && !isRoomDryingProgram(this.programNumber) && !isTargetDryingProgram(this.programNumber);
  }

  get showProgramQualityRating() {
    return (
      !this.isMonitorProgramChain &&
      !isRoomDryingProgram(this.programNumber) &&
      !isTargetDryingProgram(this.programNumber) &&
      !isActiveProgramChainOfIresDevice(this.iresDevice, this.programChain)
    );
  }

  createEmptyRating(): ProgramChainQualityRating {
    const programQualityRating: ProgramQualityRating = {
      phaseRatings: {},
    };

    this.phases.forEach((phase) => {
      programQualityRating.phaseRatings[phase] = {
        ratings: {
          phaseChange: null,
          pauses: null,
          activity: null,
        },
      };
    });

    const hasPostDryingRun = this.programChain.runs.some((run) =>
      isPostDryingProgram(run.programNumber)
    );

    if (hasPostDryingRun) {
      programQualityRating.phaseRatings["postDrying"] = {
        ratings: {
          phaseChange: null,
          pauses: null,
          activity: null,
        },
      };
    }

    const dryingQualityRating: DryingQualityRating = {
      dryingSpeed: null,
      flow: null,
      roomTemperature: null,
      roomHumidity: null,
    };

    const overallDryingRating: OverallDryingRating = {
      dryingDuration: null,
      dryingProcess: null,
      knowledgeGain: null,
    };

    const notesDryingRating: NotesDryingRating = {
      anomalies: [],
      general: [],
      roomConditions: [],
      roomTemperature: [],
      EDTGeneral: [],
      EDTPhase4: [],
      EDTPauses: [],
    };

    const defaultNoteText = joinToString(
      [formatDate(new Date(), "dd.MM.yyyy HH:mm"), getActiveUser()?.nickname],
      " / "
    );

    return {
      notesDryingRating: notesDryingRating,
      labels: [],
      createdAt: firestore.Timestamp.now(),
      createdByClientId: getClientId(),
      createdByUserId: getActiveUserId() as string,
      createdByUserNickname: getActiveUser()?.nickname ?? "",
      note: `${defaultNoteText}\n`,
      dryingQualityRating: dryingQualityRating,
      programQualityRating: programQualityRating,
      overallDryingRating: overallDryingRating,
    };
  }

  onNoteInput() {
    this.didEditNoteText = true;
  }

  inialRating: ProgramChainQualityRating | null = null;

  async showRatingInfo(programChain: ProgramChain) {
    this.didEditNoteText = false;

    const dryingPhaseInfo = getDryingPhaseInfoOfProgramChain(programChain);
    const phases = new Set<number>();

    dryingPhaseInfo.forEach((info) => {
      phases.add(info.phase);
    });

    this.phases = [...phases.values()].sort();

    const emptyRating = this.createEmptyRating();
    const qualityRating = programChain.rating ?? emptyRating;

    this.noteText = qualityRating.note ?? emptyRating.note ?? "";

    this.dryingQualityRating =
      qualityRating.dryingQualityRating ?? this.dryingQualityRating;

    this.overallDryingRating =
      qualityRating.overallDryingRating ?? this.overallDryingRating;

    this.programQualityRating =
      qualityRating.programQualityRating ?? this.programQualityRating;

    this.dryingDurationRating =
      qualityRating.dryingDurationRating ?? this.dryingDurationRating;

    if (
      qualityRating.dryingDurationRating?.shouldHaveRunLonger &&
      qualityRating.overallDryingRating?.dryingDuration === undefined
    ) {
      this.overallDryingRating.dryingDuration = -2;
      this.dryingDurationRating.shouldHaveRunLonger = false;

      this.shouldSaveMigration = true;
    }

    this.labels = qualityRating.labels ?? [];

    this.notesDryingRating = qualityRating.notesDryingRating ? JSON.parse(JSON.stringify(qualityRating.notesDryingRating)) as NotesDryingRating : this.notesDryingRating;

    if (qualityRating.notesDryingRating === undefined && this.labels.length > 0) {
      if (this.labels.includes(DryingLabel.NO_PLASTIC_SHEETING_ON_RAW_FLOOR)) {
        this.notesDryingRating["EDTGeneral"].push(0);
      }
      if (this.labels.includes(DryingLabel.UNDERFLOOR_HEATING)) {
         this.notesDryingRating["general"].push(0);
      }
      if (this.labels.includes(DryingLabel.NEW_MOISTURE_APPEARED)) {
         this.notesDryingRating["anomalies"].push(1);
      }
      if (this.labels.includes(DryingLabel.NIGHTLY_INTERRUPTION_BY_CLIENT)) {
         this.notesDryingRating["general"].push(1);
      }
      if (this.labels.includes(DryingLabel.INSUFFICIENT_AIR_FLOW)) {
        this.notesDryingRating["EDTGeneral"].push(1);
      }
      if (this.labels.includes(DryingLabel.RELAY_MALFUNCTION)) {
        this.notesDryingRating["anomalies"].push(0);
      }
      if (this.labels.includes(DryingLabel.MOISTURE_NEAR_DRILL_HOLES)) {
        this.notesDryingRating["EDTGeneral"].push(2);
      }
      if (this.labels.includes(DryingLabel.DRYING_WITH_PRE_DRIED_AIR)) {
        this.notesDryingRating["EDTGeneral"].push(3);
      }

      this.shouldSaveMigration = true;
    }

    if (this.shouldSaveMigration) {
      await this.saveRating();
      this.shouldSaveMigration = false;
    }
    this.inialRating = this.collectRatingInpunt();
  }

  collectRatingInpunt() {
    const rating: ProgramChainQualityRating = {
      createdAt: firestore.Timestamp.now(),
      createdByClientId: getClientId(),
      createdByUserId: getActiveUserId() as string,
      createdByUserNickname: getActiveUser()?.nickname ?? "",
      note: this.didEditNoteText
        ? this.noteText
        : this.programChain.rating?.note,
      dryingQualityRating: this.dryingQualityRating,
      programQualityRating: this.programQualityRating,
      overallDryingRating: this.overallDryingRating,
      dryingDurationRating: this.dryingDurationRating,
      labels: this.labels,
      notesDryingRating: JSON.parse(JSON.stringify(this.notesDryingRating)) as NotesDryingRating,
    };

    return rating;
  }

  async saveRating() {
    if (this.isSavingRating) {
      return;
    }

    const programChain = this.programChain;

    const newRating = this.collectRatingInpunt();

    this.isSavingRating = true;

    await setQualityRatingOfProgramChain(
      this.iresDevice.serialNo,
      programChain.id,
      newRating
    );

    this.isSavingRating = false;

    if (!this.shouldSaveMigration) {
      this.showRatingSavedSnackbar = true;
    }

    this.programChain.rating = newRating;

    const programChainUpdate: ProgramChain = {
      ...this.programChain,
      rating: newRating,
    };

    if (!this.shouldSaveMigration) {
      this.$emit("dryingRatingDone", programChainUpdate);
    }
  }

  async onCloseRating() {
    const existingRating = this.inialRating ?? this.createEmptyRating();
    const newRating = this.collectRatingInpunt();

    const hasRatingChanged =
      !existingRating ||
      !_.isEqual(newRating.note, existingRating.note) ||
      !_.isEqual(
        newRating.dryingQualityRating,
        existingRating.dryingQualityRating
      ) ||
      !_.isEqual(
        newRating.programQualityRating,
        existingRating.programQualityRating
      ) ||
      !_.isEqual(
        newRating.overallDryingRating,
        existingRating.overallDryingRating
      ) ||
      !_.isEqual(
        newRating.notesDryingRating,
        existingRating.notesDryingRating
      );

    if (hasRatingChanged) {
      const shouldSaveRating = await this.confirmationDialog.show({
        title: this.$t("common.unsavedChangesDialog.title").toString(),
        message: this.$t("common.unsavedChangesDialog.message").toString(),
        acceptMessage: this.$t("common.save").toString(),
        rejectMessage: this.$t(
          "common.unsavedChangesDialog.doNotSave"
        ).toString(),
      });

      if (shouldSaveRating) {
        await this.saveRating();
        return false;
      }
    }

    return true;
  }

  async onAbort() {
    const response = await this.onCloseRating();

    if (response === true) {
      this.$emit("dryingRatingDone");
    }
  }
}
